module.exports = __webpack_public_path__ + "img/linkedin share-button.5d40e91b.png";